import type { ClientGateway } from "@kex/api";

import { defineMessages } from "react-intl";

import type { BaseToken } from "./types";

export const networkNamesMessages =
  defineMessages<ClientGateway.NetworkSlugsEnum>({
    BITCOIN: {
      id: "network-name.btc",
      defaultMessage: "BTC",
    },
    ETHEREUM: {
      id: "network-name.eth",
      defaultMessage: "ERC20",
    },
    TON: {
      id: "network-name.ton",
      defaultMessage: "TON",
    },
    TRON: {
      id: "network-name.trc",
      defaultMessage: "TRC20",
    },
  });

export const baseTokenNamesMessages = defineMessages<BaseToken>({
  BTC: {
    id: "token-name.btc",
    defaultMessage: "Bitcoin",
  },
  ETH: {
    id: "token-name.eth",
    defaultMessage: "Ethereum",
  },
  TON: {
    id: "token-name.ton",
    defaultMessage: "Ton",
  },
  TRX: {
    id: "token-name.trc",
    defaultMessage: "Tron",
  },
  USDT: {
    id: "token-name.usdt",
    defaultMessage: "Tether USD",
  },
});

export const networkCodesMessages =
  defineMessages<ClientGateway.NetworkSlugsEnum>({
    BITCOIN: { id: "network-code.btc", defaultMessage: "Bitcoin" },
    ETHEREUM: { id: "network-code.eth", defaultMessage: "Ethereum" },
    TON: { id: "network-code.ton", defaultMessage: "TON" },
    TRON: { id: "network-code.trc", defaultMessage: "Tron" },
  });
